import React from "react";
import { eyeIcon } from "@excalidraw/excalidraw/components/icons";
import type { Theme } from "@excalidraw/excalidraw/element/types";
import { MainMenu } from "@excalidraw/excalidraw/index";
import { LanguageList } from "../app-language/LanguageList";
import { saveDebugState } from "./DebugCanvas";

export const AppMainMenu: React.FC<{
  onCollabDialogOpen: () => any;
  isCollaborating: boolean;
  isCollabEnabled: boolean;
  theme: Theme | "system";
  setTheme: (theme: Theme | "system") => void;
  refresh: () => void;
  ascendCurrentName: string;
  onAscendNew: () => void;
  onAscendSave: () => void;
  onAscendSaveAs: () => void;
  onAscendOpenPanel: () => void;
}> = React.memo((props) => {
  return (
    <MainMenu>
      <MainMenu.Group title="Ascend Draw">
        <MainMenu.Item aria-label="New Drawing" onSelect={props.onAscendNew}>
          New Drawing
        </MainMenu.Item>
        <MainMenu.Item
          aria-label={`Save "${props.ascendCurrentName}"`}
          onSelect={props.onAscendSave}
        >
          {`Save "${props.ascendCurrentName}"`}
        </MainMenu.Item>
        <MainMenu.Item
          aria-label="Save As New Drawing"
          onSelect={props.onAscendSaveAs}
        >
          Save As New Drawing
        </MainMenu.Item>
        <MainMenu.Item
          aria-label="My Drawings"
          onSelect={props.onAscendOpenPanel}
        >
          My Drawings...
        </MainMenu.Item>
      </MainMenu.Group>
      <MainMenu.Separator />
      <MainMenu.DefaultItems.LoadScene />
      <MainMenu.DefaultItems.SaveToActiveFile />
      <MainMenu.DefaultItems.Export />
      <MainMenu.DefaultItems.SaveAsImage />
      {props.isCollabEnabled && (
        <MainMenu.DefaultItems.LiveCollaborationTrigger
          isCollaborating={props.isCollaborating}
          onSelect={() => props.onCollabDialogOpen()}
        />
      )}
      <MainMenu.DefaultItems.CommandPalette className="highlighted" />
      <MainMenu.DefaultItems.SearchMenu />
      <MainMenu.DefaultItems.Help />
      <MainMenu.DefaultItems.ClearCanvas />
      <MainMenu.Separator />
      <MainMenu.DefaultItems.Socials />
      {import.meta.env.DEV && (
        <MainMenu.Item
          icon={eyeIcon}
          onClick={() => {
            if (window.visualDebug) {
              delete window.visualDebug;
              saveDebugState({ enabled: false });
            } else {
              window.visualDebug = { data: [] };
              saveDebugState({ enabled: true });
            }
            props?.refresh();
          }}
        >
          Visual Debug
        </MainMenu.Item>
      )}
      <MainMenu.Separator />
      <MainMenu.DefaultItems.ToggleTheme
        allowSystemTheme
        theme={props.theme}
        onSelect={props.setTheme}
      />
      <MainMenu.ItemCustom>
        <LanguageList style={{ width: "100%" }} />
      </MainMenu.ItemCustom>
      <MainMenu.DefaultItems.ChangeCanvasBackground />
    </MainMenu>
  );
});
